import React, {useState} from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import OfferTab from './OfferTab';
import Properties from './Properties';
import Activity_tab from './Activity_tab';
import Price_history from './Price_history';
import 'react-tabs/style/react-tabs.css';
import {AttributesInterface, ItemInterface} from '@api/item';
import {UserInterface} from '@api/user';

const tabId: Map<string, number> = new Map<string, number>([
  ['offers', 1],
  ['properties', 2],
  ['details', 3],
  ['activities', 4],
  ['history', 5],
]);

const ItemsTabs = ({
  item,
  tab,
  user,
  onRefresh,
  redeem,
  setOnRefresh,
}: {
  item?: ItemInterface;
  tab: string;
  user: UserInterface;
  onRefresh: string;
  redeem?: boolean;
  setOnRefresh?: (value: number) => void;
}) => {
  const [tabsActive, setTabsActive] = useState(tabId.get(tab) ?? 1);
  const tabsHeadText = redeem
    ? [
        {
          id: 2,
          text: 'Properties',
        },
        {
          id: 3,
          text: 'Details',
        },
      ]
    : [
        {
          id: 1,
          text: 'Offers',
        },
        {
          id: 2,
          text: 'Properties',
        },
        {
          id: 3,
          text: 'Details',
        },
        {
          id: 4,
          text: 'Activities',
        },
        {
          id: 5,
          text: 'Price history',
        },
      ];

  return (
    <>
      <div className="scrollbar-custom mt-6 overflow-x-auto ">
        {/* <!-- Tabs Nav --> */}
        <Tabs className="tabs">
          <TabList className="nav nav-tabs scrollbar-custom mb-10 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-100 pb-px dark:border-jacarta-600">
            {/* <!-- Offers --> */}
            {tabsHeadText.map((tabs) => {
              return (
                <Tab className="nav-item bg-transparent" key={tabs.id}>
                  <button
                    className={
                      tabsActive === tabs.id
                        ? 'nav-link hover:text-dark-navy text-grey-light-2 relative flex items-center whitespace-nowrap py-3 px-5 dark:hover:text-white active'
                        : 'nav-link hover:text-dark-navy text-grey-light-2 relative flex items-center whitespace-nowrap py-3 px-5 dark:hover:text-white'
                    }
                    onClick={() => setTabsActive(tabs.id)}
                  >
                    <span className="font-display text-base font-medium">{tabs.text}</span>
                  </button>
                </Tab>
              );
            })}
          </TabList>

          {!redeem && (
            <TabPanel className="tab-content">
              <OfferTab
                item={item as ItemInterface}
                user={user}
                onRefresh={onRefresh}
                setOnRefresh={setOnRefresh}
              />
            </TabPanel>
          )}

          <TabPanel>
            <Properties
              attributes={item?.attributes as AttributesInterface[]}
              slug={item?.Collection.slug}
              redeem={redeem}
            />
          </TabPanel>
          <TabPanel>
            {/* <!-- Details --> */}
            <div
              className="tab-pane fade"
              id="details"
              role="tabpanel"
              aria-labelledby="details-tab"
            >
              <div className="dark:bg-dark-navy dark:border-black-green border-jacarta-100 rounded-t-2lg rounded-large  border bg-white p-6 md:p-10 overflow-x-auto">
                <div className="mb-2 flex items-center">
                  <span className=" text-grey  mr-2 min-w-[9rem]">Contract Address</span>
                  <a
                    href={`${process.env.NEXT_PUBLIC_EXPLORER_URL}/${item?.contract_address}`}
                    className="text-aqua-blue"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {item?.contract_address}
                  </a>
                </div>
                <div className="mb-2 flex items-center">
                  <span className=" text-grey mr-2 min-w-[9rem]">Token ID</span>
                  <a
                    href={`${process.env.NEXT_PUBLIC_EXPLORER_URL}/${item?.contract_address}?a=${item?.tokenId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span
                      className="js-copy-clipboard text-dark-grey cursor-pointer select-none dark:text-dark-grey"
                      data-tippy-content="Copy"
                    >
                      {item?.tokenId}
                    </span>
                  </a>
                </div>
                <div className="mb-2 flex items-center">
                  <span className=" text-grey mr-2 min-w-[9rem]">Token Standard</span>
                  <span className="text-dark-grey dark:text-dark-grey">{item?.token_standard}</span>
                </div>
                <div className="flex items-center mb-2 ">
                  <span className=" text-grey mr-2 min-w-[9rem]">Blockchain</span>
                  <span className="text-dark-grey dark:text-dark-grey">{item?.chainId}</span>
                </div>
                <div className="flex items-center mb-2 ">
                  <span className=" text-grey mr-2 min-w-[9rem]">Metadata</span>
                  <span className="text-dark-grey dark:text-dark-grey">{item?.metadata}</span>
                </div>
                <div className="flex items-center  ">
                  <span className=" text-grey mr-2 min-w-[9rem]">Creator Earnings</span>
                  <span className="text-dark-grey dark:text-dark-grey">
                    {Number(item?.creatorEarnings) * 100}%
                  </span>
                </div>
              </div>
            </div>
          </TabPanel>
          {!redeem && (
            <>
              <TabPanel>
                <Activity_tab />
              </TabPanel>
              <TabPanel>
                <Price_history
                  id={item?.id}
                  classes="dark:bg-dark-navy dark:border-jacarta-600 border-jacarta-100 rounded-t-2lg rounded-b-2lg rounded-tl-none border bg-white p-6"
                />
              </TabPanel>
            </>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default ItemsTabs;
